module.exports = __webpack_public_path__ + "img/1_repair-sp.bf39dddf.jpg";